/* eslint-disable no-debugger */
import React, { useCallback, useContext, useEffect, useMemo, useState, useRef } from "react";
import Icon, { ExclamationCircleOutlined } from "@/utils/antdIcon";
import { Collapse, Modal, message } from "antd";
import { ErrorCode, Status } from "@/components/Joyspace/components/BatchDownloadPanel/type";
import {
  getSuccessDownloadTaskCount,
  getGlobalStatus,
  checkDownloadError
} from "@/components/Joyspace/components/BatchDownloadPanel/BasisComponents/utils";
import PanelHeader from "@/components/Joyspace/components/BatchDownloadPanel/BasisComponents/PanelHeader";
import Header from "@/components/Joyspace/components/BatchDownloadPanel/BasisComponents/Header";
import List from "@/components/Joyspace/components/BatchDownloadPanel/BasisComponents/Main";
import DynamicWindow from "@/pagesv2/NewWindow/DynamicWindow";
import {
  CancelIcon,
  UpIcon
} from "@/components/Joyspace/components/BatchDownloadPanel/BasisComponents/Icons";
import ImDownloadController from "./BatchDownloadController";
import events from "@/components/Joyspace/context/events";
import { btnAction } from "@/components/Joyspace/components/BatchDownloadPanel/config/btn.aciton";
import "@/components/Joyspace/components/BatchDownloadPanel/index.less";
import GlobalContext from "@/context/GlobalContext";
import DownloadService from "@/server/DownloadService";
import ImService from "@/server/ImService";
import { FileChatMessage, FileStatus } from "@/types/chat";
import { handleAddFileDownloadRecord } from "@/components/chat/utils/commonMessageModal";
import { isEqualEmployee } from "@/utils/chat/message";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import { FocusSDK, detectOS, isFocusEnv } from "@/utils";
import "./index.less";
import { StatusErrorDesc } from "./type";

interface IProps {
  className?: string;
  gid?: string;
  updateSessionMessageMid: Function;
  updateDownloadingMids: Function;
}

const { Panel } = Collapse;
let index = 0;
const ImDownloadCollapsePanel = (props: IProps & ChatState) => {
  const {
    className = "",
    gid,
    updateSessionMessageMid,
    updateDownloadingMids,
    selectedSession,
    currentEmployee
  } = props;
  const closeBtnClickLockRef = useRef(false);
  const ipcMessageRef = useRef<any>(null);
  const imDownloadControllerInstance: any = ImDownloadController.getInstance();
  const downloadServiceInstance = DownloadService.getInstance({
    updateDownloadingMids
  } as any);
  const [activeKey, setActiveKey] = useState<any>("download");
  const modalRef = useRef<any>(null);
  const { onLine } = useContext(GlobalContext);
  const [list, setList] = useState<any[]>(imDownloadControllerInstance?.getGidByTaskQueue(gid));
  imDownloadControllerInstance.proxy(setList);
  imDownloadControllerInstance.setGid(gid);
  // 添加任务&开始任务下载
  const addTaskList = useCallback(
    (list) => {
      console.log("addTaskList", list);
      for (let item of list) {
        item.gid = gid;
      }
      imDownloadControllerInstance.setGid(gid);
      // console.log(newTaskList, 'newTaskListnewTaskListnewTaskList');
      imDownloadControllerInstance.addTask(
        [...list],
        () => {
          let downloadList = imDownloadControllerInstance?.getGidByTaskQueue(gid);
          console.log("downloadList=>", downloadList);
          setList([...downloadList]);
          setActiveKey("download");
          events.emit("handleGroupUploadPanel", true);
        },
        async (currentItem: any) => {
          console.log("currentItem=>", currentItem);
          if (isFocusEnv()) {
            const imService = ImService.getInstance();
            const result = await imService.updateLocalPath(
              (currentItem as FileChatMessage).sessionId,
              (currentItem as FileChatMessage).mid,
              {
                downLocalPath: currentItem.path
              }
            );
            console.log("result=>", result);
            if (result) {
              // if (!downloadServiceInstance.downloadingMids.includes(item.mid)) {
              //   downloadServiceInstance.downloadingMids.push(mid);
              //   downloadServiceInstance.updateDownloadingMids?.([...DownloadService.downloadingMids]);
              // }
              // downloadServiceInstance.setDownloadStatus(
              //   (currentItem as any).mid,
              //   FileStatus.COMPLETED
              // );
              console.log(
                "getdownloadStatues=>",
                downloadServiceInstance.getDownloadStatus((currentItem as any).mid)
              );
              await updateSessionMessageMid({
                sessionId: (currentItem as FileChatMessage).sessionId,
                sendResult: { body: { ...currentItem, downLocalPath: currentItem.path } }
              });
            }
          } else {
            setList((prev: any) => {
              const index = prev.findIndex((item: any) => item.id === (currentItem as any).id);
              if (index > -1) {
                prev.splice(index, 1);
                return [...prev];
              }
              return [...prev];
            });
          }

          // 下载完成提交下载数据
          if (!isEqualEmployee((currentItem as FileChatMessage).sender, currentEmployee)) {
            handleAddFileDownloadRecord(
              currentItem as FileChatMessage,
              currentEmployee,
              0,
              selectedSession
            );
          }
        }
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gid]
  );
  // const handleDownloadPanel = useCallback((isUploadExpand) => {
  //   isUploadExpand && setActiveKey("");
  // }, []);
  useEffect(() => {
    if (isFocusEnv()) {
      if (!ipcMessageRef.current) {
        ipcMessageRef.current = FocusSDK.onIpcMessage("handleImDownload:addTaskList", addTaskList);
      }
      // FocusSDK.on("handleImDownload:addTaskList", addTaskList);
    } else {
      events.on("handleImDownload:addTaskList", addTaskList);
    }
    return () => {
      if (isFocusEnv()) {
        if (ipcMessageRef.current) {
          ipcMessageRef.current();
        }
        ipcMessageRef.current = null;
      } else {
        events.removeListener("handleImDownload:addTaskList", addTaskList);
      }
      // events.removeListener("handleGroupDownloadPanel", handleDownloadPanel);
    };
  }, [addTaskList]);
  const cancelPanel = useCallback(
    () => {
      index = 0;
      imDownloadControllerInstance.clearGidByTask(gid);
      // setActiveKey("");
      setList([]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [list, gid]
  );
  // 关闭面板和折叠面板
  const genExtra: any = useCallback(() => {
    const tmpList = list.filter((item: any) => item.gid === gid);
    return (
      <div>
        <span
          className={
            activeKey === "download"
              ? "collapse-icon collapse-down-icon"
              : "collapse-icon collapse-up-icon"
          }
        >
          <Icon component={UpIcon} />
        </span>
        <span
          className="collapse-cancel-icon"
          onClick={(event: any) => {
            event.stopPropagation();
            if (
              tmpList.some(
                (item: any) => item.status === Status.PROGRESS || item.status === Status.WAITING
              )
            ) {
              if (closeBtnClickLockRef.current) return;
              closeBtnClickLockRef.current = true;
              Modal.confirm({
                title: "取消下载",
                icon: <ExclamationCircleOutlined />,
                content: "下载尚未完成，要取消所有的下载吗?",
                okText: "确认",
                cancelText: "取消",
                onOk: () => {
                  cancelPanel();
                  closeBtnClickLockRef.current = false;
                },
                onCancel: () => {
                  closeBtnClickLockRef.current = false;
                }
              });
              return;
            }
            cancelPanel();
            // cancelPanel(event);
          }}
        >
          <Icon component={CancelIcon} />
        </span>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, list, gid]);
  const { currentSuccessTaskCount, totalTaskCount, gloadlStatus } = useMemo(() => {
    let tmpList = list.filter((item: any) => item.gid === gid);
    let currentSuccessTaskCount = getSuccessDownloadTaskCount(tmpList);
    let totalTaskCount = tmpList.length;
    let gloadlStatus = getGlobalStatus(tmpList);
    return { currentSuccessTaskCount, totalTaskCount, gloadlStatus };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, onLine, gid]);

  const dynamicWindowVisible = useMemo(() => {
    return list.length > 0 && isFocusEnv();
  }, [list.length]);

  return (
    <DynamicWindow
      name="文件下载进度管理"
      winOptions={{
        width: 440,
        height: 340,
        maxHeight: 340,
        x: (window.screen as any).availLeft + (window.screen as any).width - 440,
        y: (window.screen as any).availTop + 100,
        alwaysOnTop: true,
        resizable: false
      }}
      windowRef={modalRef}
      onClose={() => {
        cancelPanel();
      }}
      beforeUnloadCallback={() => {
        if (
          list
            .filter((item) => item.gid === gid)
            .some((item: any) => item.status === Status.PROGRESS || item.status === Status.WAITING)
        ) {
          return message.info("下载任务被终止");
        }
      }}
      beforeUnloadModal={{
        title: "取消下载",
        icon: <ExclamationCircleOutlined />,
        content: "下载尚未完成，要取消所有的下载吗?",
        okText: "确认",
        cancelText: "取消"
      }}
      // showToolBar={true}
      visible={dynamicWindowVisible}
    >
      <Collapse
        className={className + " collapse-box im-collapse-box"}
        bordered={false}
        accordion={true}
        activeKey={activeKey ? [activeKey] : []}
        onChange={(key) => {
          console.log(key, "keykeykeykeykeykeykey");
          setActiveKey("download");
          // events.emit("handleGroupUploadPanel", Boolean(key));
        }}
      >
        {/* 批量下载 */}
        {list.length > 0 && (
          <Panel
            showArrow={false}
            header={
              <PanelHeader
                className="imPanelHeader"
                draggable={true}
                status={gloadlStatus}
                currentSuccessTaskCount={currentSuccessTaskCount}
                totalTaskCount={totalTaskCount}
              />
            }
            key="download"
            extra={genExtra()}
          >
            <Header
              status={gloadlStatus}
              currentSuccessTaskCount={currentSuccessTaskCount}
              totalTaskCount={totalTaskCount}
              handleCancelAll={() => {
                imDownloadControllerInstance.handleTaskCancelAll(gid);
              }}
              handleRetryAll={() => {
                imDownloadControllerInstance.handleTaskRetryAll(gid);
              }}
            />
            <List
              list={list.filter((item: any) => item.gid === gid)}
              callback={async (item: any) => {
                // item.options.onStarted(item);
                let applyFn = Status.ERROR;
                if (item.status === Status.PROGRESS || item.status === Status.WAITING) {
                  applyFn = Status.CANCEL;
                } else if (item.status === Status.CANCEL || item.status === Status.RETRY) {
                  applyFn = Status.RETRY;
                } else if (item.status === Status.SUCCESS) {
                  applyFn = Status.SUCCESS;
                } else {
                  applyFn = Status.ERROR;
                }
                if (applyFn === Status.SUCCESS) {
                  const path = `${item.path}${detectOS() === "Win" ? "\\" : "/"}${item.title}`;
                  const isExist = await imDownloadControllerInstance.checkLocalPathExist(path);
                  console.warn(isExist, "isExist===> 路径", path);
                  isExist
                    ? FocusSDK.showItemInFolder(path)
                    : message.error(StatusErrorDesc.FILE_PATH_NOT_EXIST);
                } else {
                  btnAction[applyFn](imDownloadControllerInstance, item, onLine ? index++ : index);
                }
              }}
            />
          </Panel>
        )}
      </Collapse>
    </DynamicWindow>
  );
};
function mapStateToProps({ chat }: any) {
  const { selectedSession, currentEmployee } = chat as ChatState;
  return {
    selectedSession,
    currentEmployee
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      return dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },

    updateDownloadingMids(data: string[]) {
      dispatch({ type: "chat/updateDownloadingMids", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImDownloadCollapsePanel);
